var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import * as Styled from "./zoom-box.style";
import { round } from "utility/number";
var MIN_WIDTH_PX = 12;
export var ZoomBox = function (_a) {
    var startFraction = _a.startFraction, endFraction = _a.endFraction, totalWidth = _a.totalWidth, toDisplayTime = _a.toDisplayTime, onChange = _a.onChange;
    var _b = __read(useState(startFraction), 2), localStart = _b[0], setLocalStart = _b[1];
    var _c = __read(useState(endFraction), 2), localEnd = _c[0], setLocalEnd = _c[1];
    var _d = __read(useState(false), 2), isDragging = _d[0], setIsDragging = _d[1];
    var dragRef = useRef(null);
    var pendingChange = useRef(null);
    // Sync from parent when not dragging
    useEffect(function () {
        if (!dragRef.current) {
            setLocalStart(startFraction);
            setLocalEnd(endFraction);
        }
    }, [startFraction, endFraction]);
    var onMouseDown = useCallback(function (type) { return function (e) {
        e.preventDefault();
        dragRef.current = {
            type: type,
            startClientX: e.clientX,
            startFraction: localStart,
            startEndFraction: localEnd,
        };
        setIsDragging(true);
        var onMouseMove = function (moveEvent) {
            var drag = dragRef.current;
            if (!drag)
                return;
            var delta = (moveEvent.clientX - drag.startClientX) / totalWidth;
            var newStart = drag.startFraction;
            var newEnd = drag.startEndFraction;
            var minWidthFraction = MIN_WIDTH_PX / totalWidth;
            if (drag.type === "left") {
                newStart = Math.max(0, Math.min(drag.startFraction + delta, newEnd - minWidthFraction));
            }
            else if (drag.type === "right") {
                newEnd = Math.min(1, Math.max(drag.startEndFraction + delta, newStart + minWidthFraction));
            }
            else {
                var width_1 = drag.startEndFraction - drag.startFraction;
                newStart = Math.max(0, Math.min(drag.startFraction + delta, 1 - width_1));
                newEnd = newStart + width_1;
            }
            setLocalStart(newStart);
            setLocalEnd(newEnd);
            pendingChange.current = [newStart, newEnd];
        };
        var onMouseUp = function () {
            var _a;
            var dragType = (_a = dragRef.current) === null || _a === void 0 ? void 0 : _a.type;
            dragRef.current = null;
            setIsDragging(false);
            if (pendingChange.current && dragType) {
                var _b = __read(pendingChange.current, 2), start = _b[0], end = _b[1];
                onChange(start, end, dragType);
                pendingChange.current = null;
            }
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
        };
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    }; }, [localStart, localEnd, totalWidth, onChange]);
    var leftTime = toDisplayTime(localStart);
    var rightTime = toDisplayTime(localEnd);
    var left = localStart * totalWidth;
    var width = (localEnd - localStart) * totalWidth;
    return (_jsxs(Styled.Outer, { left: left, width: width, onDragStart: function (e) { return e.preventDefault(); }, onClick: function (e) { return e.stopPropagation(); }, children: [_jsx(Styled.Handle, { onMouseDown: onMouseDown("left") }), _jsx(Styled.Body, { dragging: isDragging, onMouseDown: onMouseDown("body") }), _jsx(Styled.Handle, { onMouseDown: onMouseDown("right") }), _jsx(Styled.Label, { children: "".concat(round(leftTime, 2), " - ").concat(round(rightTime, 2)) })] }));
};
